module.exports = __webpack_public_path__ + "static/media/exhibition-services-img14.ffe8ad8f.jpg";